import $1nISI$mitt from "mitt";
import {v4 as $1nISI$v4} from "uuid";
import $1nISI$symboltree from "symbol-tree";




class $7c968f807e86b920$export$dc04438abaadc40 {
    constructor(){
        this.element = null;
        this.document = null;
        if (!globalThis?.document) return;
        this.document = globalThis.document;
        const container = this.document?.querySelector('#debug-visualize') || null;
        if (!container) return;
        container.style.display = 'block';
        container.style.maxHeight = '50vh';
        container.style.overflowY = 'auto';
        container.style.fontSize = '1.5em';
        this.element = this.document?.createElement('div') || null;
        this.element?.classList.add('console');
        if (this.element) {
            this.element.style.width = '100%';
            container.appendChild(this.element);
        }
    }
    getPrint(level) {
        return (...args)=>{
            if (!this.element) return;
            let string = '';
            args.forEach((arg, i)=>{
                if (!arg) return;
                if (i > 0) string += ' ';
                if (typeof arg === 'string' && arg.startsWith && arg.startsWith('%c')) arg = arg.substring(2);
                if (arg === 'font-weight:bold;') return;
                if (typeof arg === 'string' && arg.substring) string += arg;
                else string += JSON.stringify(arg);
            });
            const entry = this._getEntryElement(level, string);
            if (this.element && entry) {
                if (this.element.childElementCount > 0) {
                    const insertionPoint = this.element.firstElementChild;
                    this.element.insertBefore(entry, insertionPoint);
                } else this.element.appendChild(entry);
            }
        };
    }
    get log() {
        return this.getPrint('log');
    }
    get warn() {
        return this.getPrint('warn');
    }
    get error() {
        return this.getPrint('error');
    }
    _getEntryElement(level, content) {
        let borderColor = '#aaa';
        let textColor = '#222';
        if (level === 'warn') {
            textColor = '#540';
            borderColor = '#870';
        } else if (level === 'error') {
            textColor = '#500';
            borderColor = '#800';
        }
        const entry = this.document?.createElement('CODE') || null;
        if (entry) {
            entry.innerText = content;
            entry.classList.add('debug-visualize__entry');
            entry.classList.add(`debug-visualize__entry--${level}`);
            entry.style.display = 'block';
            entry.style.marginBottom = '1rem';
            entry.style.padding = '.25rem';
            entry.style.paddingLeft = '.5rem';
            entry.style.backgroundColor = '#ddd';
            entry.style.borderLeft = `10px solid ${borderColor}`;
            entry.style.color = textColor;
            return entry;
        }
        return null;
    }
}


const $ec0e259d2aad5b8c$var$eventProxy = (0, $1nISI$mitt)();
const $ec0e259d2aad5b8c$var$DEFAULT_GLOBAL_OPTIONS = {
    grouped: false,
    dotted: false
};
class $ec0e259d2aad5b8c$var$BasicDebugHelper {
    constructor(id, _namespace = [], enabled = true, tags = []){
        this.id = id;
        this._namespace = _namespace;
        this.enabled = enabled;
        this.tags = tags;
        this.onToggle = ({ enabled: enabled })=>{
            this.enabled = enabled;
        };
        this.listen();
    }
    spawn(id = null, namespace = null, startsEnabled = true, ...tags) {
        let childId;
        if (id === null) childId = (0, $1nISI$v4)();
        else if (typeof id !== 'string') childId = id.constructor?.name;
        else childId = id;
        const childNamespace = [
            ...this._namespace
        ];
        if (namespace !== null) {
            let parsedNamespace;
            if (namespace === true) parsedNamespace = childId;
            else if (typeof namespace !== 'string') parsedNamespace = namespace.constructor?.name || '';
            else parsedNamespace = namespace;
            childNamespace.push(parsedNamespace);
        }
        const child = new $ec0e259d2aad5b8c$var$BasicDebugHelper(childId, childNamespace, startsEnabled, tags);
        $ec0e259d2aad5b8c$var$eventProxy.emit('register', {
            instance: child,
            parent: this
        });
        return child;
    }
    addTags(...tags) {
        this.tags.push(...tags);
        this.listenForTags(tags);
        return this;
    }
    enable() {
        this.toggle(true);
        return this;
    }
    disable() {
        this.toggle(false);
        return this;
    }
    toggle(enabled) {
        this.enabled = enabled;
        return this;
    }
    message(type, message) {
        $ec0e259d2aad5b8c$var$eventProxy.emit('message', {
            type: type,
            instance: this,
            message: message
        });
    }
    log(...args) {
        this.message('log', [
            ...args
        ]);
    }
    warn(...args) {
        this.message('warn', [
            ...args
        ]);
    }
    error(...args) {
        this.message('error', [
            ...args
        ]);
    }
    devnull(...args) {
        return args;
    }
    async timeout(ms) {
        return new Promise((res)=>{
            setTimeout(()=>res(), ms);
        });
    }
    getPrefix() {
        return this._namespace;
    }
    listen() {
        $ec0e259d2aad5b8c$var$eventProxy.on(`toggle_${this.id}`, this.onToggle);
        this.listenForTags(this.tags);
    }
    listenForTags(tags) {
        tags.forEach((tag)=>{
            $ec0e259d2aad5b8c$var$eventProxy.on(`toggle_${tag}`, this.onToggle);
        });
    }
}
class $ec0e259d2aad5b8c$var$GlobalDebugHelper extends $ec0e259d2aad5b8c$var$BasicDebugHelper {
    constructor(){
        super('Global', []), this._visualize = false, this._visualizer = new (0, $7c968f807e86b920$export$dc04438abaadc40)(), this.options = $ec0e259d2aad5b8c$var$DEFAULT_GLOBAL_OPTIONS, this.globallyEnabled = false, this.tree = new (0, $1nISI$symboltree)(), this.onRegister = ({ instance: instance, parent: parent })=>{
            this.tree.appendChild(parent, instance);
        }, this.onMessage = ({ type: type, message: message, instance: instance })=>{
            if (!this.globallyEnabled) return;
            if (!this.checkOriginEnabled(instance)) return;
            this[type](...this.prefix(...instance.getPrefix()), ...message);
            this.suffix();
        };
        $ec0e259d2aad5b8c$var$eventProxy.on('message', this.onMessage);
        $ec0e259d2aad5b8c$var$eventProxy.on('register', this.onRegister);
    }
    getOptions() {
        return this.options;
    }
    get events() {
        return $ec0e259d2aad5b8c$var$eventProxy;
    }
    toggleVisualization(enabled) {
        this._visualize = enabled;
        return this;
    }
    log(...args) {
        if (this.globallyEnabled) {
            console.log(...args);
            if (this._visualize) this._visualizer.log(...args);
        }
    }
    warn(...args) {
        if (this.globallyEnabled) {
            console.warn(...args);
            if (this._visualize) this._visualizer.warn(...args);
        }
    }
    error(...args) {
        if (this.globallyEnabled) {
            console.error(...args);
            if (this._visualize) this._visualizer.error(...args);
        }
    }
    toggle(enabled) {
        this.globallyEnabled = enabled;
        return this;
    }
    configure(config = null, options = null) {
        if (config) Object.keys(config).forEach((instanceIdOrTag)=>{
            const shouldBeEnabled = config[instanceIdOrTag];
            $ec0e259d2aad5b8c$var$eventProxy.emit(`toggle_${instanceIdOrTag}`, {
                enabled: shouldBeEnabled
            });
        });
        if (options) this.options = {
            ...this.options,
            ...options
        };
        return this;
    }
    decorate(prefix = null, ...tags) {
        return function withDebugDecorator(constructor, context = null) {
            const base = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            constructor.prototype?.debug || $ec0e259d2aad5b8c$export$1c9f709888824e05;
            const name = context?.name || constructor.name || null;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            constructor.prototype.debug = base.spawn(name, prefix).addTags(...tags);
            return constructor;
        };
    }
    listen() {}
    prefix(...strings) {
        const prefix = this.preparePrefix(strings);
        if (this.doGrouping()) {
            console.group(...prefix);
            return [];
        }
        return prefix;
    }
    doGrouping() {
        return this.options.grouped && typeof console.group === 'function';
    }
    preparePrefix(strings) {
        if (this.options.dotted) {
            const prefix = strings.map((s)=>s.trim()).join('.');
            return this.doGrouping() ? [
                prefix
            ] : [
                `[${prefix}]`
            ];
        } else return strings.map((s)=>`[${s.trim()}]`);
    }
    suffix() {
        if (this.options.grouped && typeof console.groupEnd === 'function') console.groupEnd();
    }
    checkOriginEnabled(instance) {
        return instance.enabled && this.tree.ancestorsToArray(instance).every((parent)=>parent.enabled);
    }
}
const $ec0e259d2aad5b8c$export$1c9f709888824e05 = new $ec0e259d2aad5b8c$var$GlobalDebugHelper();


export {$ec0e259d2aad5b8c$export$1c9f709888824e05 as debug};
//# sourceMappingURL=index.mjs.map
